import angular from 'angular';
import { v4 as uuidv4 } from 'uuid';
import './resource';
import { localStorage } from '../utils';

const module = angular.module('whyline.resources.connect-wizard', [
  'whyline.resources.resource',
]);

const ConnectWizardFactory = ($http, $q, API_URL, Resource) => {
  /*@ngInject*/
  //API REST Resource Name
  const _type = 'connectWizard';
  const url = `${API_URL}configuration/connect`;

  const _schema = {
    apiUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    apiClientSecret: {
      type: String,
      required: true,
      default: uuidv4()
    },
    apiClientKey: {
      type: String,
      required: true,
      default: uuidv4()
    }
  };

  const ConnectWizard = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  const handleGetResponse = promise =>
    promise
      .then(response => {
        ConnectWizard.SetConnectAlreadySetup(!!response.data);
        ConnectWizard.localCache = response.data;
        return response.data;
      })
      .catch(() => ConnectWizard.SetConnectAlreadySetup(false));

  const handleSaveResponse = (promise, dataToCache) =>
    promise
      .then(response => {
        ConnectWizard.SetConnectAlreadySetup(true);
        ConnectWizard.localCache = dataToCache;
        return response.data;
      });

  const getDataToCache = dataToCache => ({
    apiUrl: dataToCache.apiUrl,
    name: dataToCache.name,
    email: dataToCache.email,
    apiClientKey: dataToCache.apiClientKey
  });

  ConnectWizard.localCache = null;

  ConnectWizard.SetConnectAlreadySetup = value => localStorage.set('IsConnectAlreadySetUp', value);

  ConnectWizard.GetConnectAlreadySetup = () => localStorage.get('IsConnectAlreadySetUp');

  ConnectWizard.IsConnectAlreadySetUp = () => {
    const defer = $q.defer();
    const IsConnectAlreadySetUp = ConnectWizard.GetConnectAlreadySetup();
    if (IsConnectAlreadySetUp) {
      defer.resolve(true);
    } else if (IsConnectAlreadySetUp === undefined) {
      ConnectWizard.GetAsPromise()
        .then(() => defer.resolve(ConnectWizard.GetConnectAlreadySetup()));
    } else {
      defer.resolve(false);
    }

    return defer.promise;
  };

  ConnectWizard.GetAsPromise = () => {
    const defer = $q.defer();

    if (!ConnectWizard.localCache) {
      return handleGetResponse($http.get(url));
    } else {
      defer.resolve(ConnectWizard.localCache);
      return defer.promise;
    }
  };

  ConnectWizard.SaveConnectData = dataToSave => {
    return handleSaveResponse($http.post(url, dataToSave), getDataToCache(dataToSave));
  };

  ConnectWizard.UpdateConnectData = dataToSave => {
    const dataToCache = getDataToCache(dataToSave);
    // We don't send this props because they can't be changed
    Reflect.deleteProperty(dataToSave, 'apiClientKey');
    Reflect.deleteProperty(dataToSave, 'email');
    return handleSaveResponse($http.put(url, dataToSave), dataToCache);
  };

  ConnectWizard.prototype = new Resource(_type, _schema, ConnectWizard);

  Resource.Extend(_type, ConnectWizard);

  const validityTime = 5 * 60 * 1000;
  ConnectWizard.InitCache(validityTime);

  return ConnectWizard;
};

module.exports = module.factory('ConnectWizard', ConnectWizardFactory);
